export default "__VITE_ASSET__D4v8yafs__"